
import { Component, Vue } from 'vue-property-decorator'
import { CourseModule } from '../../store/modules/course'
import { UserModule } from '../../store/modules/user'
import DashboardHeader from '../../components/Dashboards/DashboardHeader.vue'
import CourseOccupy from '../../components/course/course-occupy.vue'
import AuditionSign from '../../components/course/audition-sign.vue'
import AddListBusiness from '../../components/course/add-list-business.vue'
@Component({
  name: 'sign',
  filters: {
    formatDate: function(value, type) {
      if (!value) {
        return
      }
      let date = new Date(value * 1000)
      let y: any = date.getFullYear()
      let MM: any = date.getMonth() + 1
      MM = MM < 10 ? ('0' + MM) : MM
      let d: any = date.getDate()
      d = d < 10 ? ('0' + d) : d
      let h: any = date.getHours()
      let next_h = h < 9 ? ('0' + (h + 1)) : (h + 1)
      h = h < 10 ? ('0' + h) : h
      let m: any = date.getMinutes()
      m = m < 10 ? ('0' + m) : m
      let s: any = date.getSeconds()
      s = s < 10 ? ('0' + s) : s
      if (type == 1) {
        return y + '-' + MM + '-' + d + ' ' + h + ':' + m + '-' + next_h + ':' + m
      } else if (type == 2) {
        return y + '-' + MM + '-' + d + ' ' + h + ':' + m
      }
    }
  },
  components: { DashboardHeader, CourseOccupy, AuditionSign, AddListBusiness } 
})
export default class extends Vue {
    org_id: string = 'd06455545e6d4b929f4fbacbdc93dd24'
    studentId: string = ''
    studentCourseList:any = []
    campus_id: string = ''
    campus: any = []
    employee: any = []
    employeeSelect: any = []
    studentList: any = []
    zskStudent: any = []
    ages: string = ''
    business_id: any = [] // 姓名筛选
    dialogNoShop: boolean = false  // 无意向到店
    dialogNoShopTitle: string = '' // 无意向到店title
    studentRowData: any = {}
    auditionSignTitle: string = ''
    auditionSignPop: boolean = false
    total_count: number = 0
    page: number = 1

    labelArr: any = [
      {
        id: 7,
        name: '未签到'
      },
      {
        id: 4,
        name: '签到'
      },
      {
        id: 5,
        name: '无意向到店'
      },
      {
        id: 6,
        name: '爽约'
      }
    ]
    changedetailTeacherId: string = '' // 上课老师监听
    changeStatusId: any = [] // 状态监听
    signType: number = 1
    historyList: any = []
    itemId: string = '' // id
    // 课程记录
    value: string = ''
    // 公共筛选
    instrumentTypes = []
    // teacherType = []
    campusType = []
    time: any = [new Date(<any>new Date() - 1000 * 60 * 60 * 24 * 30),new Date()]
    start_time: any =  ''
    end_time: any = ''
    courseType: any = []
    courseTypeSelect: any = []
    from: any = ''
    course_type: string = ''  // 1 正式课 2 试听课
    levelSelect: any = []
    outType: boolean = true

    remark: string = ''
    customerIntention: any = 4
    selectStudentStatus: any = []
    dialogBusinessAdd: boolean = false
    business_modifyHeader: any = []
    business_optionList: any = []
    business_optionId: string = ''
    business_itemValue: any = {}
    business_isAddType: string = 'edit'
    business_pageName: string = ''
    business_allData: any = []
    loading: boolean = true
    mounted() {
      this.getUrl()
      this.getStudent()
      this.getBusinessList()
    }

    async getBusinessData(business_id) {
      const res: any = await CourseModule.getBusinessDetails({ business_id: business_id, is_show: 1 })
      if(res.code === 200) {
        this.business_itemValue = res.data[0]
        this.dialogBusinessAdd = true
      }
    }
    getBusinessDetails(val) {
      this.dialogBusinessAdd = false
    }
    getBusinessDetail(val){
      this.getBusinessData(val.business_id)
    }

    async businessOption() {
      const res: any = await CourseModule.options({ optionId: this.business_optionId, org_id: this.org_id })
      if (res.code === 200) {
        this.business_optionList = res.data
      }
    }
    async getBusinessList() {
      const res: any = await CourseModule.businessPage({ org_id: this.org_id })
      if (res.code === 200) {
        let header = res.data.page_section[0].entity.entity_fields
        for (var i = 0; i < header.length; i++) {
          const existsType: string = header[i].exists_type
          if (existsType.indexOf('modify') >= 0) {
            this.business_modifyHeader.push(header[i])
          }
        }
        this.business_optionId = res.data.page_section[0].entity.id
        this.business_pageName = res.data.key
        this.business_allData = res.data
        this.businessOption()
        this.loading = false
      }
    }

    //  历史搜索
    async selectHistory() {
      const page_name: string = '2'
      const res: any = await CourseModule.selectHistory({page_name: page_name})
      if(res.data.business_id) {
        this.business_id = res.data.business_id.split(',')
      } else {
        this.business_id = []
      }

      if (res.data.sign_type) {
        const arr = res.data.sign_type.split(',')
        this.selectStudentStatus = []
        this.changeStatusId = []
        for (var i = 0; i < arr.length; i++) {
          this.selectStudentStatus.push(Number(arr[i]))
          this.changeStatusId.push(Number(arr[i]))
        }
      } else {
        this.selectStudentStatus = []
        this.changeStatusId = []
      }
      this.getStudentCourse() //  课程记录
    }
    handleCurrentChange(val) {
      this.page = val
      this.getStudentCourse()
    }
    // 状态监听
    changeStatus(val) {
      this.changeStatusId = val
      this.getStudentCourse()
    }

    getUrl() {
      this.from = this.$route.query.from
      const key: any = this.$route.query.key
      const value: any = this.$route.query.value
      let time: any = this.$route.query.time
      let campus: any = this.$route.query.campus
      let teacher: any = this.$route.query.teacher
      let instrument: any = this.$route.query.instrument

      if(this.from) {
        if(key === 'zhengshi' || key === 'shiting') {
          this.course_type = value
        } else if (key === 'course_type_id') {
          this.courseTypeSelect = [ value ]
        } else if (key === 'level_id') {
          this.outType = true
          this.levelSelect = [ value ]
        } else if (key === 'ages') {
          this.ages = value
        }
        this.selectHistory()
      } else {
        this.selectHistory()
      }
    }

    //  子组件返回数据
    getDataChange(val){
      this.instrumentTypes = val.instrumentTypes
      this.employeeSelect = val.teacherType
      this.campusType = val.campusType
      this.time = val.time
      if (this.time.length > 0) {
        this.start_time = Date.parse(this.time[0])/1000
        this.end_time = Date.parse(this.time[1])/1000
      } else {
        this.start_time = ''
        this.end_time = ''
      }
      this.selectHistory()
    }

    // 学员列表查询
    async getStudent() {
      const res: any = await CourseModule.getBusiness({ business_id: '', customer_id: '' })
      if (res.code === 200) {
        this.studentList = res.data
      }
    }

    async getStudentCourse() {
      this.changeStatusId = this.changeStatusId.toString()
      const res: any = await CourseModule.auditionCourseSign({'business_id': this.business_id,'course_type_id': this.courseTypeSelect, 'teacher_id': this.employeeSelect.toString(), 'sign_type': this.changeStatusId, 'instrument_type_id': this.instrumentTypes.toString(), 'campus_id': this.campusType, 'start_time': this.start_time.toString(), 'end_time': this.end_time.toString(), 'page': this.page, 'size': 10 })
      this.studentCourseList = res.data.list
      this.total_count = res.data.total
    }

    // 状态筛选
    signTypeClick(id,val) {
      if((id != 4 && val.sign_type === 4) || (id != 5 && val.sign_type === 5)) {
        return false
      }
      this.studentId = val.student_id
      this.itemId = val.id
      this.studentRowData = val
      if (id === val.sign_type) {  // 编辑
        if(id === 6) {
          this.dialogNoShopTitle = '确认爽约？'
          this.signType = 6
          this.dialogNoShop = true
          this.remark = val.teacher_remark
        } else if (id === 5) {
          this.dialogNoShopTitle = '确认无意向到店？'
          this.signType = 5
          this.dialogNoShop = true
          this.remark = val.teacher_remark
        } else if (id === 4) {
          this.signType = 4
          this.auditionSignPop = true
          this.remark = val.teacher_remark
          if(val.business === 3) {
            this.customerIntention = 4
          } else {
            this.customerIntention = val.business_status
          }
        }
      } else { // 新建
        if(id ===  5) {
          this.dialogNoShopTitle = '确认无意向到店？'
          this.signType = 5
          this.dialogNoShop = true
        } else if (id === 6) {
          this.dialogNoShopTitle = '确认爽约？'
          this.signType = 6
          this.dialogNoShop = true
        } else if (id === 4) {
          this.signType = 4
          this.auditionSignPop = true
          this.remark = ''
          this.customerIntention = 4
        }
      }
    }

    // 签到方法
    async signIn(data) {
      data.org_id = this.org_id
      const res: any = await UserModule.getClassSign(data)
      if (res.code === 200) {
        this.$message({
          type: 'success',
          message: res.message
        })
        this.dialogNoShop = false
        this.auditionSignPop = false


        this.getStudentCourse()
      } else {
        this.$message.error('操作失败！')
      }
    }


    // 监听正式课学员列表
    changeZskStudent(val) {
      this.business_id = val
      this.getStudentCourse()
    }
    noShopBack(val) {
      if(val.type === 'true') {
        let data:any = {
          teacher_remark: val.desc,
          sign_type: this.signType,
          id: this.studentRowData.id,
          course_type: 2
        }
        this.signIn(data)
      } else {
        this.dialogNoShop = false
        this.getStudentCourse()
        
      }
    }

    auditionSign(val) {
      if(val.type === 'false') { // 取消
        this.auditionSignPop = false
        this.getStudentCourse()
      } else {
        let data = {
          business_status: val.customerIntention,
          course_type: 2,
          id: this.studentRowData.id,
          teacher_remark: val.stkShopReason,
          sign_type: this.signType
        }
        this.signIn(data)
      }
    }
}
